import { connect } from 'react-redux'
import lineSelector from './lineSelector'
import Line from './Line'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  lineSelector
)(Line))
